export enum ProductLabelingState{
  ReleasedMedicalDevice = "RMD",
  ReleasedNonMedicalDevice = "RNMD",
  UnreleasedDevice = "UD"
}
